import React, { useEffect, useState } from 'react';
import { i3Assets } from '../utils/i3Assets';
import '../styles/I3PageHero.css';

export type I3PageHeroProps = {
  title: string;
  subtitle?: string;
  /** When true, title is only for screen readers / outline (nav already shows the page name) */
  titleScreenReaderOnly?: boolean;
  /** White traced I-3 logo above title (roses hero; e.g. Journal hub) */
  showLogo?: boolean;
};

const I3PageHero: React.FC<I3PageHeroProps> = ({ title, subtitle, titleScreenReaderOnly, showLogo }) => {
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduceMotion(mq.matches);
    const handler = () => setReduceMotion(mq.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return (
    <header
      className={`i3-page-hero${showLogo ? ' i3-page-hero--with-logo' : ''}`}
      aria-label="Page header"
    >
      {!reduceMotion && (
        <div className="i3-page-hero-video-wrap" aria-hidden>
          <video
            className="i3-page-hero-video"
            autoPlay
            muted
            loop
            playsInline
            aria-hidden
          >
            <source src="/videos/Roses.mp4" type="video/mp4" />
          </video>
        </div>
      )}
      <div className="i3-page-hero-overlay" aria-hidden />
      <div className="i3-page-hero-content">
        {showLogo ? (
          <div className="i3-page-hero-logo-wrap" aria-hidden>
            <img src={i3Assets.logos.whiteTraced} alt="" className="i3-page-hero-logo-img" />
          </div>
        ) : null}
        {titleScreenReaderOnly ? (
          <h1 className="i3-page-hero-sr-only">{title}</h1>
        ) : (
          <h1 className="i3-page-hero-title">{title}</h1>
        )}
        {subtitle && (
          <p
            className={
              titleScreenReaderOnly
                ? 'i3-page-hero-subtitle i3-page-hero-subtitle--prominent'
                : 'i3-page-hero-subtitle'
            }
          >
            {subtitle}
          </p>
        )}
      </div>
    </header>
  );
};

export default I3PageHero;
